<div class="dialog-wrapper">
  <!--<h2 mat-dialog-title>Dr. Klein Partnerportal im neuen Design</h2>
  <mat-dialog-content class="mat-typography"
                      style="font-size: medium; max-width: 33em; margin-top: 2rem; margin-bottom: 2rem;">
    Lieber Partnerportal-Nutzer,<br/><br/>

    <p>das Dr. Klein Partnerportal hat einen neuen Anstrich bekommen.
      Neben dem neuen, intuitiveren Design werden schon bald viele neue Funktionen folgen!</p>

    Sehen Sie sich jetzt das neue Partnerportal an! Ihnen gefällt das neue Design nicht?
    Kein Problem, Sie können noch eine ganze Weile zurück in das alte Design wechseln.

  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <div class="w-100 text-center">
      <button mat-raised-button mat-dialog-close>Ich bleibe noch etwas beim alten Design</button>&nbsp;&nbsp;&nbsp;
      <a href="/tng">
        <button color="primary" mat-raised-button [mat-dialog-close]="true">Ich möchte das neue Design
          sehen
        </button>
      </a>
    </div>
  </mat-dialog-actions>-->
  <p *ngIf="url; else loadingSpinner" style="font-size: large">
    Bitte klicken Sie <a [href]="url">hier</a>, wenn keine automatische Weiterleitung vom Browser erfolgt.
  </p>
  <ng-template #loadingSpinner>
    <mat-spinner></mat-spinner>
  </ng-template>
</div>
